const NavigationTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <nav className="gencrm_app__navigation">
      <div className="gencrm_app__navigation-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`gencrm_app__navigation-tab ${activeTab === tab.id ? 'gencrm_app__navigation-tab--active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon && <span className="gencrm_app__navigation-icon">{tab.icon}</span>}
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default NavigationTabs;
